// extracted by mini-css-extract-plugin
export default {"menuItem":"menuItem--oergn","menuItemText":"menuItemText--XsTML"};